<template functional>
  <div class="bg-primary-tint-5 p-8" :class="[data.class, data.staticClass]">
    <div
      class="
        max-w-5xl
        gap-8
        grid grid-cols-2
        md:grid-cols-4
        lg:grid-cols-5
        w-full
        justify-items-center
        items-center
        m-auto
      "
    >
      <div
        v-for="{ img, src, label } in props.items"
        :key="label || src"
        class="flex flex-col items-center"
      >
        <component :is="img" v-if="img" />
        <img v-if="src" :src="src" alt="" />
        <div v-if="label" class="font-bold text-center">{{ label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeroIcons from '@/constants/SubHeroIcons';

export default {
  props: {
    items: {
      type: Array,
      default: () => SubHeroIcons,
    },
  },
};
</script>
